import { LitElement, html, css } from 'lit';

class FacilityImagesViewer extends LitElement {
  static properties = {
    images: { type: Array, reflect: true },
    selectedImageIndex: { type: Number, reflect: true }
  }
  static styles = css`
    .facility-images {
      position: relative;
      margin-bottom: 40px;
    }

    .facility-images .fadein {
      animation: fadeIn 0.5s ease 0s 1 normal;
    }

    .facility-images .center {
      text-align: center;
    }

    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }

    .facility-images .facility-main-image {
      object-fit: cover;
      aspect-ratio: 360/240;
      width: 100%;
      max-width: 540px;
      min-width: 360px;
      min-height: 240px;
      margin-bottom: 16px;
    }

    .facility-images .facility-image-list {
      display: inline-flex;
      flex-wrap: nowrap;
      flex-shrink: 0;
      text-align: center;
      column-gap: 16px;
      overflow-x: auto;
      max-width: 540px;
      width: 100%;
      justify-content: start;
    }

    @media screen and (min-width: 1060px) {
      .facility-images .facility-image-list {
        justify-content: center;
      }
    }

    .facility-images .facility-image-list .facility-image {
      display: inline-block;
      margin: 0 0 12px 0;
    }

    .facility-images .facility-image-list .facility-image img {
      object-fit: cover;
      aspect-ratio: 1/1;
      width: 64px;
      height: 64px;
    }

    .facility-images .facility-image-list .facility-image.selected img {
      border: 2px solid #D76315;
      box-sizing: border-box;
      object-fit: cover;
      aspect-ratio: 1/1;
    }

    .facility-images .facility-image-frame {
      position: relative;
      width: 100%;
      max-width: 540px;
      display: inline-block;
    }

    .facility-images .facility-image-frame .left-arrow {
      position: absolute;
      left: 0px;
      top: calc(50% - 26px);
    }

    .facility-images .facility-image-frame .right-arrow {
      position: absolute;
      right: 0px;
      top: calc(50% - 26px);
    }

    .facility-images .facility-image-nav {
      margin-top: 12px;
      text-align: center;
    }

    .facility-images .facility-image-nav-circle {
      margin: 0 6px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: #fff;
      border: 2px solid #A8ABA6;
      display: inline-block;
    }

  .facility-images .facility-image-nav-circle.selected {
    border: 2px solid #D76315;
  }
  `
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.images = [];
    this.selectedImageIndex = 0;

    setInterval(() => {
      const imageCount = this.images.length
      this.selectedImageIndex = (this.selectedImageIndex + 1) % imageCount;
    }, 6000);

  }
  prevImage() {
    this.selectedImageIndex = (this.selectedImageIndex - 1 + this.images.length) % this.images.length;
  }
  nextImage() {
    this.selectedImageIndex = (this.selectedImageIndex + 1) % this.images.length;
  }
  render() {
    return html`
      <div class="facility-images">
        <div class="center">
          <div class="center facility-image-frame">
            ${this.images.map((url, i) => html`
              <img class="facility-main-image ${i === this.selectedImageIndex ? 'fadein' : ''}" src="${url}" ?hidden="${i !== this.selectedImageIndex}" loading="${i == 0 ? 'eager' : 'lazy'}" alt="image-${i}">
            `)}
            <div class="left-arrow" @click="${this.prevImage}">
              <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                <g filter="url(#filter0_d_1005_32217)">
                  <circle cx="22" cy="22" r="16" fill="white"/>
                  <path d="M22.067 29.0939L24.4142 26.7361L21.3577 23.6796H29.0531V20.3274H21.3577L24.4142 17.271L22.067 14.9132L14.9767 22.0035L22.067 29.0939ZM21.9975 40C19.5209 40 17.1883 39.5286 14.9996 38.5858C12.8109 37.643 10.9018 36.3569 9.27244 34.7276C7.64305 33.0982 6.35697 31.1894 5.4142 29.0014C4.4714 26.8133 4 24.481 4 22.0045C4 19.5083 4.4714 17.1658 5.4142 14.9771C6.35697 12.7884 7.64268 10.8841 9.27134 9.26434C10.9 7.64454 12.8085 6.36221 14.9969 5.41734C17.1853 4.47245 19.518 4 21.9949 4C24.4915 4 26.8344 4.47225 29.0237 5.41677C31.213 6.36131 33.1173 7.64317 34.7368 9.26235C36.3562 10.8815 37.6383 12.7855 38.583 14.9745C39.5277 17.1634 40 19.5064 40 22.0035C40 24.4807 39.5276 26.8136 38.5827 29.0023C37.6378 31.1909 36.3555 33.0996 34.7357 34.7284C33.1159 36.3572 31.2119 37.643 29.0239 38.5858C26.8358 39.5286 24.4937 40 21.9975 40Z" fill="#A8ABA6"/>
                </g>
                <defs>
                  <filter id="filter0_d_1005_32217" x="0" y="0" width="44" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0.14902 0 0 0 0 0.196078 0 0 0 0 0.219608 0 0 0 0.16 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1005_32217"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1005_32217" result="shape"/>
                  </filter>
                </defs>
              </svg>
            </div>
            <div class="right-arrow" @click="${this.nextImage}">
              <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                <g filter="url(#filter0_d_1005_32218)">
                  <circle cx="22" cy="22" r="16" fill="white"/>
                  <path d="M21.9259 29.0939L29.0163 22.0035L21.9259 14.9132L19.5787 17.271L22.6352 20.3274H14.9398V23.6796H22.6352L19.5787 26.7361L21.9259 29.0939ZM21.9975 40C19.5209 40 17.1883 39.5286 14.9996 38.5858C12.8109 37.643 10.9018 36.357 9.27244 34.7276C7.64305 33.0982 6.35697 31.1894 5.4142 29.0014C4.4714 26.8133 4 24.481 4 22.0045C4 19.5083 4.4714 17.1658 5.4142 14.9771C6.35697 12.7884 7.64268 10.8841 9.27134 9.26434C10.9 7.64454 12.8085 6.36221 14.9969 5.41734C17.1853 4.47245 19.518 4 21.9949 4C24.4915 4 26.8344 4.47225 29.0237 5.41677C31.213 6.36131 33.1173 7.64317 34.7368 9.26235C36.3562 10.8815 37.6383 12.7855 38.583 14.9745C39.5277 17.1634 40 19.5064 40 22.0035C40 24.4807 39.5276 26.8136 38.5827 29.0023C37.6378 31.1909 36.3555 33.0996 34.7357 34.7284C33.1159 36.3572 31.2119 37.643 29.0239 38.5858C26.8358 39.5286 24.4937 40 21.9975 40Z" fill="#A8ABA6"/>
                </g>
                <defs>
                  <filter id="filter0_d_1005_32218" x="0" y="0" width="44" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0.14902 0 0 0 0 0.196078 0 0 0 0 0.219608 0 0 0 0.16 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1005_32218"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1005_32218" result="shape"/>
                  </filter>
                </defs>
              </svg>
            </div>
          </div>
          <div class="facility-image-list">
            ${this.images.map((url, i) => html`
              <div @click="${() => this.selectedImageIndex = i}" class="facility-image ${i === this.selectedImageIndex ? 'selected' : ''}">
                <img src="${url}">
              </div>
            `)}
          </div>
          <div class="facility-image-nav">
            ${this.images.map((url, i) => html`
              <div @click="${() => this.selectedImageIndex = i}" class="facility-image-nav-circle ${i === this.selectedImageIndex ? 'selected' : ''}"></div>
            `)}
          </div>
        </div>
      </div>
    `;
  }
}
customElements.define('facility-images-viewer', FacilityImagesViewer);